import { FC } from 'react'

type IconMailProps = {
  className?: string
}

export const IconMail: FC<IconMailProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="41"
      viewBox="0 0 41 41"
      width="41"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.16683 7.3335H33.8335C35.6668 7.3335 37.1668 8.8335 37.1668 10.6668V30.6668C37.1668 32.5002 35.6668 34.0002 33.8335 34.0002H7.16683C5.3335 34.0002 3.8335 32.5002 3.8335 30.6668V10.6668C3.8335 8.8335 5.3335 7.3335 7.16683 7.3335Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M37.1668 10.667L20.5002 22.3337L3.8335 10.667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}
